import React, { useEffect, useState } from 'react';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Loading, Toast } from '../../components';
import { getUser, updateUser } from '../../redux/actions/userActions';
import { handleChange } from '../../utils/util';

const Profile = () => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isNewPasswordEmpty, setIsNewPasswordEmpty] = useState(true);
  const {
    user, isLoading, error, editUser
  } = useSelector((state) => state.userReducer);
  const [isProfileValid, setIsProfileValid] = useState({
    nombre: false,
    telefono: false,
    apellido: false,
    email: false,
    dni: false,
    newPassword: false,
    currentPassword: false,
  });

  const [form, setForm] = useState({
    nombre: '',
    telefono: '',
    apellido: '',
    email: '',
    dni: '',
    newPassword: '',
    currentPassword: '',
  });
  const checkValidation = () => {
    const filterForm = Object.keys(form)
      .filter((key) => key !== 'newPassword');
    const isFormEmpty = filterForm.some((key) => form[key] === '');
    if (!isFormEmpty) {
      const dataUser = Object.values(isProfileValid);
      return dataUser.find((value) => value === true);
    }
    return true;
  };

  useEffect(() => {
    dispatch(getUser());
  }, []);

  useEffect(() => {
    setIsNewPasswordEmpty(form.currentPassword === '');
  }, [form.currentPassword]);

  useEffect(() => {
    const newUser = { ...form, ...user, currentPassword: '' };
    setForm(newUser);
    if (editUser) {
      setIsDisabled(true);
    }
  }, [user]);

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  const handleEdit = () => {
    setForm({ ...form, ...user });
    setIsDisabled(!isDisabled);
  };

  const submit = () => {
    const x = checkValidation();
    if (!x) {
      dispatch(updateUser(form));
    }
  };

  if (isLoading) return <Loading />;

  const myProfile = [{
    type: 'text',
    id: 'nombre',
    text: 'Nombre',
    isValid: isProfileValid.nombre,
    value: form.nombre,
    onChange: (name, e) => handleChange(name, e, form, setForm, isProfileValid, setIsProfileValid)
  }, {
    type: 'text',
    id: 'telefono',
    text: 'Telefono',
    isValid: isProfileValid.telefono,
    value: form.telefono,
    onChange: (name, e) => handleChange(name, e, form, setForm, isProfileValid, setIsProfileValid)
  }, {
    type: 'text',
    id: 'apellido',
    text: 'Apellido',
    isValid: isProfileValid.apellido,
    value: form.apellido,
    onChange: (name, e) => handleChange(name, e, form, setForm, isProfileValid, setIsProfileValid)
  }, {
    type: 'text',
    id: 'email',
    text: 'Email',
    isValid: isProfileValid.email,
    value: form.email,
    onChange: (name, e) => handleChange(name, e, form, setForm, isProfileValid, setIsProfileValid)
  }, {
    type: 'text',
    id: 'dni',
    text: 'DNI',
    isValid: isProfileValid.dni,
    value: form.dni,
    onChange: (name, e) => handleChange(name, e, form, setForm, isProfileValid, setIsProfileValid)
  }];

  return (
    <div className="profile-container">
      <Toast error={error} />
      <div className="profile-header">
        <p>Mi perfil</p>
        {isDisabled && <button onClick={handleEdit} className="buttonProfile-turn-profile">Editar</button>}
      </div>
      <div
        className={`container-profile-input ${isHovered ? 'container-profile-input--hovered' : ''}`}
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
      >
        {myProfile.map((input) => (
          <Input
            name={input.id}
            isValid={input.isValid}
            title={input.text}
            value={input.value}
            isDisabled={isDisabled}
            onChange={(name, e) => input.onChange(input.id, e)}
          />
        ))}
        {!isDisabled && (
          <>
            <div>
              <Input
                name="newPassword"
                isValid={isProfileValid.newPassword}
                title="Nueva Contraseña"
                value={form.newPassword}
                isDisabled={isDisabled}
                onChange={(name, e) => handleChange(
                  name,
                  e,
                  form,
                  setForm,
                  isProfileValid,
                  setIsProfileValid
                )}
              />
              <p className="title-newPass">Deje la nueva contraseña en blanco si no desea cambiarla</p>
            </div>
            <div className="new-password">
              <div className="input-pass">
                <Input
                  name="currentPassword"
                  isValid={isProfileValid.currentPassword}
                  title="Contraseña Actual"
                  value={form.currentPassword}
                  isDisabled={isDisabled}
                  onChange={(name, e) => handleChange(
                    name,
                    e,
                    form,
                    setForm,
                    isProfileValid,
                    setIsProfileValid
                  )}
                />
              </div>
              <div className="buttons-password">
                <button onClick={handleEdit} className="buttonCancel-turn-profile">Cancelar</button>
                <button
                  onClick={submit}
                  disabled={isNewPasswordEmpty}
                  className={`buttonGuardar-turn-profile${form.currentPassword === '' ? ' buttonGuardar-turn-profile--disabled' : ''}`}
                >
                  Guardar

                </button>
              </div>
            </div>
          </>
        )}

      </div>

    </div>
  );
};

export default Profile;
